import { renderApiDomain } from "../helper/renderApiDomain";
import { get } from "../helper/request";

export const getRegulationApi = async () => {
  return get(`${renderApiDomain()}regulations`);
};
